import { ajaxActions } from '../AjaxActions';

const BASE_URL = process.env.REACT_APP_TASK_SERVICE_URL;

export const fetchReminderConfig = () => ajaxActions.get(`${BASE_URL}/reminder/config`).then((resp) => resp);

export const patchReminderConfig = (patch) =>
  ajaxActions.patch(`${BASE_URL}/reminder/config`, patch).then((resp) => resp);
